/* Theme css - ModernHaus-SoHo */


import { StyleSheet } from 'react-native';



export const theme = {


  PRIMARY_FONT: {
    fontFamily: 'ProximaNovaCond-Regular',
    fontWeight: 600,
  },
  SECONDARY_FONT: {
    fontFamily: 'Poppins-Regular',
    fontWeight: 400,
  },
  TERTIARY_FONT: {
    fontFamily: "Termina-Demi",
    fontWeight: 600
  },
  TERTIARY_FONT_LIGHT: {
    fontFamily: "Termina-Light",
    fontWeight: 300
  },

  FONT_XSMALL: {
    fontSize: 8,
  },
  FONT_SMALL: {
    fontSize: 12,
    lineHeight: 18,
  },
  FONT_MEDIUM: {
    fontSize: 14,
    lineHeight: undefined,
  },
  FONT_LARGE: {
    fontSize: 22,
    lineHeight: undefined,
    letterSpacing: 1
  },
  FONT_XLARGE: {
    fontSize: 22,
    lineHeight: undefined,
     letterSpacing: 1
  },
  FONT_XXLARGE: {
    fontSize: 22,
    lineHeight: undefined,
    letterSpacing: 1
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#FFFFFF', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#343434',

    BACKGROUND_COLOR_SECONDARY: "#F6F6F3", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#708066",

    PRIMARY_COLOR: "#FFFFFF", // primary color
    PRIMARY_TEXT_COLOR: "#343434", // primary text color

    SECONDARY_COLOR: "#708066", // secondary color
    SECONDARY_TEXT_COLOR: "#F6F6F3", // secondary text color

    ACCENT_COLOR: "#EABE51",
    ACCENT_Text_COLOR: "#3B4765"
  },
};


export default StyleSheet.create({
  
  primaryBtn: {
    borderRadius: 8,
    shadowColor: "transparent",
    borderWidth: 1,
    borderColor: "#708066"
  },
  primaryBtnTxt: {
    ...theme.TERTIARY_FONT
  },
  secondaryBtn: {
    borderRadius: 8,
    shadowColor: "transparent"
  },
  secondaryBtnTxt: {
    ...theme.TERTIARY_FONT
  },
  tertiaryBtn: {
    borderRadius: 8,
    shadowColor: "transparent"
  },
  tertiaryBtnTxt: {
    ...theme.TERTIARY_FONT
  },

  input: {
    borderRadius: 8,
  },

  Dropdown: {
    borderRadius: 8,
  },
  dropdown_web: {
    borderRadius: 8,
  },

  mainContainerHeaderContainer: {
    display: "none"
  },


  welcomeScreenPrimaryBtn: {
    backgroundColor: "#F6F6F3"
  },
  welcomeScreenPrimaryBtnTxt: {
    color: "#708066"
  },

  welcomeScreenTertiaryBtn: {
    backgroundColor: "#708066"
  },
  welcomeScreenTertiaryBtnTxt: {
    color: "#F6F6F3"
  },
  
  
  headerContainerLogo: {
    height: 32,
    width: 70
  },

  promoWidgetContainer: {
    minHeight: 262,
    height: 262
  },


  multipleSmallWidgetContainer: {
    paddingVertical: 32,
  },
  multipleSmallWidget_MainWidgetsContainer: {
    gap: 16,
    maxWidth: 750
  },
  multipleSmallWidgetTitleText: {
    textTransform: "uppercase"
  },
  multipleSmallWidgetTitleTextContainer: {
    maxWidth: "100%"
  },
  multipleSmallWidget_WidgetsContainer: {
    borderRadius: 8,
    overflow: "hidden"
  },
  multipleSmallWidget_WidgetsTitleText: {
    ...theme.FONT_MEDIUM,
    textTransform: "uppercase"
  },

  bannerWidgetMultipleImageStyle: {
    borderRadius: 8,
    overflow: "hidden"
  },
  bannerMultipleMultipleWidgetTitleText: {
    textTransform: "uppercase"
  },
  bannerWidgetMultipleTitle: {
    ...theme.PRIMARY_FONT,
    textTransform: "uppercase"
  },

  infoWidgetsWidgetContainer: {
    paddingVertical: 32
  },
  infoWidgetHeaderSubtitle: {
    paddingHorizontal: 0,
    ...theme.FONT_SMALL
  },

  multipleLargeWidgetContainer: {
    paddingVertical: 16
  },
  multipleLargeWidgetTitleContainer: {
    display: "none"
  },
  multipleLargeWidget_WidgetsContainer: {
    borderRadius: 8,
    overflow: "hidden"
  },

  multipleLargeWidget_WidgetsTitleText: {
    textTransform: "uppercase"    
  },

  multipleLargeWidget_WidgetsButtonContainer: {
    borderBottomWidth: 0,
    borderBottomColor: "transparent"
  },
  multipleLargeWidget_WidgetsButtonContainerText: {
    color: theme.COLORS.WHITE,
    ...theme.TERTIARY_FONT_LIGHT,
    textTransform: "uppercase"
  },

  bannerWidgetMultipleMainContainer: {
    paddingVertical: 16
  },

  guestDetailsWidgetContainer: {
    paddingVertical: 32
  },

  guestDetailsDateItemContainer: {
    borderRadius: 8,
    borderColor: "#D9D9D9"
  },
  guestDetailsDateItemTitle: {
    ...theme.TERTIARY_FONT_LIGHT,
    ...theme.FONT_SMALL,
    color: "#858585"
  },
  guestDetailsDateItemSubTitle: {
    ...theme.FONT_SMALL,
  },

  list_itemContainer_image: {
    borderRadius: 8,
    overflow: "hidden"
  }


});
